export class AverageWindow {
  private readonly values: number[];
  private cursor = 0;
  private filled = false;

  constructor(
    private readonly capacity: number,
    private readonly fallback: number,
  ) {
    this.values = new Array<number>(capacity);
  }

  get sampleCount(): number {
    return this.filled ? this.capacity : this.cursor;
  }

  get currentValue(): number {
    const count = this.sampleCount;
    if (count === 0) return this.fallback;
    let sum = 0;
    for (let index = 0; index < count; index++) {
      sum += this.values[index];
    }
    return sum / count;
  }

  addValue(value: number): void {
    this.values[this.cursor] = value;
    this.cursor = (this.cursor + 1) % this.capacity;
    if (this.cursor === 0) this.filled = true;
  }
}
